export default "__VITE_ASSET__TdgYfJYt__"